import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/virtual-offices/adopcion')({
  beforeLoad: () => {
    throw redirect({ to: '/virtual-offices' });
  },
  component: () => null,
});
